import * as accountApi from './account';
import * as authApi from './auth';
import { mytoverInstance } from './client';
import * as contentApi from './content';
import * as feedbackApi from './feedback';
import * as kpiApi from './kpi';
import * as partnersApi from './partners';
import * as policiesApi from './policies';
import * as reportsApi from './reports';
import * as translationsApi from './translations';
import * as unitsApi from './units';
import * as usersApi from './users';

// Re-export all the individual APIs for direct use
export * from './account';
export * from './auth';
export * from './content';
export * from './feedback';
export * from './kpi';
export * from './partners';
export * from './policies';
export * from './reports';
export * from './translations';
export * from './units';
export * from './users';

// Export the MyToverAPI class for backward compatibility
export class MyToverAPI {
  // Menu
  static getMenu = contentApi.getMenu;

  // Auth
  static signin = authApi.signin;
  static signInAsGuest = authApi.signInAsGuest;
  static checkQrAccess = authApi.checkQrAccess;
  static signout = authApi.signout;

  // Users
  static getUser = usersApi.getUser;
  static getUserUnits = usersApi.getUserUnits;
  static getUserActivity = usersApi.getUserActivity;
  static getUsers = usersApi.getUsers;
  static getUsersPerUnit = unitsApi.getUsersPerUnit;
  static getMyToverAccessBySerialNumber = unitsApi.getMyToverAccessBySerialNumber;
  static getInvitedUser = usersApi.getInvitedUser;
  static getRelatedUsers = usersApi.getRelatedUsers;
  static inviteUsers = usersApi.inviteUsers;
  static getUserInviteOptions = usersApi.getUserInviteOptions;
  static resendInvitation = usersApi.resendInvitation;
  static removeUser = usersApi.removeUser;
  static deleteUser = usersApi.deleteUser;
  static editUser = usersApi.editUser;
  static removeUserUnitRelation = usersApi.removeUserUnitRelation;
  static requestInvite = usersApi.requestInvite;
  static acceptInvite = usersApi.acceptInvite;

  // Units
  static getUnit = unitsApi.getUnit;
  static getUnits = unitsApi.getUnits;
  static setUnitName = unitsApi.setUnitName;
  static getUnitInviteOptions = unitsApi.getUnitInviteOptions;
  static getUnitActivity = unitsApi.getUnitActivity;

  // Partners
  static getPartners = partnersApi.getPartners;
  static getPartner = partnersApi.getPartner;
  static updatePartner = partnersApi.updatePartner;
  static getPartnerUsers = partnersApi.getPartnerUsers;
  static getPartnerUnits = partnersApi.getPartnerUnits;
  static unlinkPartnerUser = partnersApi.unlinkPartnerUser;
  static verifyPartnerEmailDomain = partnersApi.verifyPartnerEmailDomain;

  // Account
  static getAccountInfo = accountApi.getAccountInfo;
  static updateAccount = accountApi.updateAccount;
  static deleteAccount = accountApi.deleteAccount;
  static recoverAccount = accountApi.recoverAccount;
  static updateEmail = accountApi.updateEmail;
  static recoverEmail = accountApi.recoverEmail;
  static verifyEmail = accountApi.verifyEmail;
  static updatePassword = accountApi.updatePassword;
  static getProfileImages = accountApi.getProfileImages;
  static setLocale = accountApi.setLocale;

  // Activation
  static setPasswordActivation = usersApi.setPasswordActivation;

  // Password
  static requestPasswordReset = usersApi.requestPasswordReset;
  static sendPasswordReset = usersApi.sendPasswordReset;

  // Content
  static getLocales = contentApi.getLocales;
  static getArticles = contentApi.getArticles;
  static getFeaturedArticles = contentApi.getFeaturedArticles;
  static getArticle = contentApi.getArticle;
  static updateArticle = contentApi.updateArticle;
  static refreshArticle = contentApi.refreshArticle;
  static refreshArticles = contentApi.refreshArticles;
  static getAttachment = contentApi.getAttachment;
  static getCategories = contentApi.getCategories;
  static getCategory = contentApi.getCategory;

  // Support
  static getSoftwareUpdate = contentApi.getSoftwareUpdate;
  static getConfigurationLink = contentApi.getConfigurationLink;

  // Feedback
  static getFeedback = feedbackApi.getFeedback;
  static postFeedback = feedbackApi.postFeedback;
  static getFeedbackQuestions = feedbackApi.getFeedbackQuestions;

  // Reports
  static getReports = reportsApi.getReports;

  // Policy
  static getPrivacyPolicy = policiesApi.getPrivacyPolicy;
  static acceptPrivacyPolicy = policiesApi.acceptPrivacyPolicy;
  static getEULA = policiesApi.getEULA;
  static acceptEULA = policiesApi.acceptEULA;
  static getProcessorTerms = policiesApi.getProcessorTerms;

  // KPI
  static getKpis = kpiApi.getKpis;

  // Translations
  static updateTranslations = translationsApi.updateTranslations;
}

// Export the mytoverInstance for direct use
export { mytoverInstance };
